module.exports = __webpack_public_path__ + "img/zd-down-5.c35ae62e.svg";